import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, CardHeader, Button, Input, FormGroup, Label, FormFeedback } from "reactstrap";
import axios from "axios";
import { API_URL, getApiConfig } from "views/composant/Config/apiConfig.js";

export default function AlertMailSetup() {
  const [boitiers, setBoitiers] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [selectedBoitier, setSelectedBoitier] = useState("");
  const [selectedAlert, setSelectedAlert] = useState("");
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");
  const [emails, setEmails] = useState([""]);
  const [emailErrors, setEmailErrors] = useState([false]);

  useEffect(() => {
    axios.get(API_URL + "showBoitierList", getApiConfig())
      .then(res => setBoitiers(res.data))
      .catch(() => setBoitiers([]));
    axios.get(API_URL + "alert_boitier_list", getApiConfig()) //mettre la bonne route
      .then(res => setAlerts(res.data))
      .catch(() => setAlerts([]));
  }, []);

  const handleEmailChange = (idx, value) => {
    const newEmails = [...emails];
    newEmails[idx] = value;
    setEmails(newEmails);
    const newErrors = [...emailErrors];
    newErrors[idx] = !validateEmail(value);
    setEmailErrors(newErrors);
  };

  const addEmailField = () => {
    setEmails([...emails, ""]);
    setEmailErrors([...emailErrors, false]);
  };

  const removeEmailField = (idx) => {
    if (emails.length === 1) return;
    setEmails(emails.filter((_, i) => i !== idx));
    setEmailErrors(emailErrors.filter((_, i) => i !== idx));
  };

  const validateEmail = (email) => {
    // Simple regex for email validation
    return /^\S+@\S+\.\S+$/.test(email);
  };

  const handleNumberInput = (value) => {
    // Autorise chiffres et une seule virgule
    return value.replace(/[^\d,]/g, '').replace(/(,.*),/g, '$1');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: envoyer la config au backend
    // ce fera en 2 post : 
    // 1. Création de l'alerte avec : boitier, type d'alerte, minValue, maxValue
    // 2. ajout des emails de l'alert dans la table boitier DU BOITIER
    // sous forme : email1;email2 en string
    const emailsString = emails.filter(email => email).join(";");
    
  };

  return (
    <Card className="mt-4">
      <CardHeader>
        <h4>Configurer une alerte e-mail</h4>
      </CardHeader>
      <CardBody>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={4}>
              <FormGroup>
                <Label>Boîtier</Label>
                <Input
                  type="select"
                  value={selectedBoitier}
                  onChange={e => setSelectedBoitier(e.target.value)}
                  required
                >
                  <option value="">Sélectionner un boîtier</option>
                  {boitiers.map(b => (
                    <option key={b.id} value={b.id}>{b.id}, {b.comment}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label>Type d'alerte</Label>
                <Input
                  type="select"
                  value={selectedAlert}
                  onChange={e => setSelectedAlert(e.target.value)}
                  required
                >
                  <option value="">Sélectionner une alerte</option>
                  {alerts.map(a => (
                    <option key={a.id} value={a.id}>{a.label}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Valeur min</Label>
                <Input
                  type="text"
                  value={minValue}
                  onChange={e => setMinValue(handleNumberInput(e.target.value))}
                  pattern="^\d+(,\d+)?$"
                  title="Chiffres et une seule virgule autorisés"
                  required
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Valeur max</Label>
                <Input
                  type="text"
                  value={maxValue}
                  onChange={e => setMaxValue(handleNumberInput(e.target.value))}
                  pattern="^\d+(,\d+)?$"
                  title="Chiffres et une seule virgule autorisés"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <Label>Emails de notification</Label>
              {emails.map((email, idx) => (
                <Row key={idx} className="align-items-center mb-2">
                  <Col md={6}>
                    <Input
                      type="email"
                      value={email}
                      onChange={e => handleEmailChange(idx, e.target.value)}
                      invalid={email.length > 0 && emailErrors[idx]}
                      placeholder="Saisir un email"
                      required
                    />
                    <FormFeedback>Adresse e-mail invalide</FormFeedback>
                  </Col>
                  <Col md="auto">
                    {emails.length > 1 && (
                      <Button color="danger" onClick={() => removeEmailField(idx)} type="button">-</Button>
                    )}
                  </Col>
                  {idx === emails.length - 1 && (
                    <Col md="auto">
                      <Button color="primary" onClick={addEmailField} type="button">+</Button>
                    </Col>
                  )}
                </Row>
              ))}
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Button color="success" type="submit">Créer l’alerte</Button>
            </Col>
          </Row>
        </form>
      </CardBody>
    </Card>
  );
}
